export default "__VITE_ASSET__BRJ750hy__"